import Decimal from 'decimal.js';

import { DEMOCRATIC_COLOR, REPUBLICAN_COLOR } from 'constants/partyColors';
import Palette from 'DesignSystem2/Theme/Palette';

export type MarginPresentation = { kind: 'party'; topParty: 'D' | 'R' } | { kind: 'candidate'; label: string };

export function formatCandidateMargin(value: number, label: string): string {
    const rounded = new Decimal(value).toDecimalPlaces(1);
    return `${label} ${rounded.isPositive() && !rounded.isZero() ? '+' : ''}${rounded.toFixed(1)}`;
}

export function formatPartyMargin(value: number): string {
    const rounded = new Decimal(value).toDecimalPlaces(1);
    if (rounded.isZero()) return 'Even';
    return `${rounded.isPositive() ? 'R' : 'D'} +${rounded.abs().toFixed(1)}`;
}

export function partyMarginColor(value: number): string {
    if (new Decimal(value).toDecimalPlaces(1).isZero()) return Palette.Text.x10;
    return value > 0 ? REPUBLICAN_COLOR : DEMOCRATIC_COLOR;
}

/** Five symmetric ticks, with headroom based on the observed margin rather than index bounds. */
export function partyMarginTicks(values: number[]): number[] {
    const extent = Math.max(0.5, ...values.map(Math.abs)) * 1.1;
    const magnitude = 10 ** Math.floor(Math.log10(extent));
    const bound = Math.ceil(extent / magnitude) * magnitude;
    return [-bound, -bound / 2, 0, bound / 2, bound];
}
